import { List, TextField, Datagrid, SelectField, DateField, SelectInput, NumberField, SimpleList } from "react-admin";
import { useMediaQuery } from "@mui/material";
import { RankingResultCategoryChoices, RankingResultStatusChoices } from "utils/choices";
import { MOBILE_BREAKPOINT, RankingResultCategory } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const RankingResultsList = props => {
  const { specialityId, rankingUrl } = props;
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const resultsFilters = [
    <SelectInput
      source="group"
      label="Категория"
      choices={RankingResultCategoryChoices.filter(c => c.id !== RankingResultCategory.RestoredRights)}
      alwaysOn
      emptyText={"Всички"}
    />,
    <SelectInput
      source="status"
      label="Статус"
      choices={RankingResultStatusChoices}
      alwaysOn
      emptyText={"Всички"}
    />,
  ];

  return (
    <List
      title={false}
      resource={`${rankingUrl}/results/${specialityId}`}
      filters={resultsFilters}
      sx={{ padding: 2 }}
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Вх. номер", value: record?.number }]} />
              <MobileListRow fields={[{ label: "Име", value: record?.fullName }]} />
            </div>
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Бал",
                    value: (
                      <NumberField
                        source="score"
                        sortable={false}
                        options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow fields={[{ label: "Желание", value: record?.specialityPriorityNumber }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Категория",
                    value: <SelectField source="group" choices={RankingResultCategoryChoices} sortable={false} />,
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: <SelectField source="status" choices={RankingResultStatusChoices} sortable={false} />,
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Последна промяна",
                    value: <DateField source="updatedAt" showTime locales="bg-BG" sortable={false} />,
                  },
                ]}
              />
            </div>
          )}
        />
      ) : (
        <Datagrid bulkActionButtons={false}>
          <TextField
            source="number"
            label="Вх. номер"
            sortable={false}
          />
          <TextField
            label="Име"
            source="fullName"
            sortable={false}
          />
          <NumberField
            label="Бал"
            source="score"
            sortable={false}
            options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
          />
          <TextField
            label="Желание"
            source="specialityPriorityNumber"
            sortable={false}
          />
          <SelectField
            label="Категория"
            source="group"
            choices={RankingResultCategoryChoices}
            sortable={false}
          />
          <SelectField
            label="Статус"
            source="status"
            choices={RankingResultStatusChoices}
            sortable={false}
          />
          <DateField
            label="Последна промяна"
            source="updatedAt"
            showTime
            locales="bg-BG"
            sortable={false}
          />
        </Datagrid>
      )}
    </List>
  );
};

export default RankingResultsList;
